<template>
    <div class="notification" :data-type="data.type||null">
        <div>{{ data.text }}</div>
        <button @click="close">x</button>
    </div>
</template>

<script>
export default {
    name: "Notification",
    props: ['data'],
    methods: {
        close() {
            this.$store.commit('closeNotification', this.data)
        }
    }
}
</script>

<style scoped>

</style>
